import { getApiActionTypes } from '../redux_utils';

export const ACTIONS = {
  ...getApiActionTypes('FETCH_PRO_DETAILS_BY_ID'),
  ...getApiActionTypes('FETCH_AVAILABLE_PROS_BY_DATE'),
};
